export default {
  host: process.env.VUE_APP_API_URL,
};
